import { render, staticRenderFns } from "./SMSSenderVendor.vue?vue&type=template&id=b14d4604&"
import script from "./SMSSenderVendor.vue?vue&type=script&lang=js&"
export * from "./SMSSenderVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports